<template v-if="data">
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Movement Strategy" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Movement Strategy</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editMode = true" v-if="!editMode">Edit</vs-button>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-else>Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Template Name *" v-model="data.name" :disabled="!editMode"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-3/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Template Description *" v-model="data.description" :disabled="!editMode"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Type</label>
                                <vs-select
                                    class="selectExample"
                                    v-model="data.type"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in typeOptions" :key="index" :value="item.value" :text="item.text"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
            <vs-card class="p-4 mb-6">
                <vs-list v-if="editMode">
                    <draggable :list="strategyOptions" class="cursor-move">
                            <vs-list-item class="flex items-center p-1 list-item pt-10 pb-10" v-for="(item, index) in strategyOptions" :key="index" :title="item.name" :subtitle="item.description">
                                    <vs-checkbox v-model="item.enable" v-if="checkboxReady" :disabled="!editMode">Enable</vs-checkbox>
                            </vs-list-item>
                    </draggable>
                </vs-list>
                <vs-list v-else>
                    <vs-list-item class="flex items-center p-1 list-item pt-10 pb-10" v-for="(item, index) in strategyOptions" :key="index" :title="item.name" :subtitle="item.description">
                            <vs-checkbox v-model="item.enable" v-if="checkboxReady" :disabled="!editMode">Enable</vs-checkbox>
                    </vs-list-item>
                </vs-list>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
    import draggable from 'vuedraggable'

	export default {
		components:{
            vSelect,
            draggable
		},
		data(){
			return {
                isLoading: false,
                detailsCount: 0,
                data: {
                    name: '',
                    description: '',
                    type: 'Pick'
                },
                pickOptions: [],
                putOptions: [],
                typeOptions: [
                    {
                        value: 'Pick',
                        text: 'Pick'
                    },
                    {
                        value: 'Put',
                        text: 'Put'
                    }
                ],
                strategyOptions: [],
                checkboxReady: false,
                editMode: false
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            },
            strategyOptions: function() {
                this.checkboxReady = false
                this.$nextTick(() => {
                    this.checkboxReady = true
                })
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            submitForm() {
                this.isLoading = true
                const details = []

                this.strategyOptions.map((item, index) => {
                    details.push({
                        no_priority: index + 1,
                        msd_id: item.id,
                        enable: item.enable ? 1 : 0,
                    })
                })

                const data = {
                    movement_strategy: {
                        name: this.data.name,
                        description: this.data.description,
                        type: this.data.type,
                    },
                    details: details
                }

                this.$http.put('master/movementstrategy/' + this.$route.params.id + '/update', data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Updated successfully.'
                    })
                    this.$router.push({ name: 'master-movement-strategy' })
                })
                .catch(error => this.handleError(error))
            },
            back() {
                this.$router.push({name: 'master-movement-strategy'})
            },
            fetchAllData() {
                this.isLoading = true
                this.$http.get('master/movementstrategy/' + this.$route.params.id)
                .then(res => {
                    this.data.name = res.data.name
                    this.data.description = res.data.description
                    this.data.type = res.data.type

                    this.strategyOptions = res.data.details.map(item => {
                        return {
                            id: item.id,
                            name: item.movement_strategy_list.name,
                            description: item.movement_strategy_list.description,
                            enable: item.enable
                        }
                    })
                        // this.pickOptions = pick.data
                    // this.putOptions = put.data
                    // this.strategyOptions = pick.data

                    // this.pickOptions.map(item => {
                    //     item.enable = true
                    // })

                    // this.putOptions.map(item => {
                    //     item.enable = true
                    // })

                    // this.data.type = 'Pick'

                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.push({name: 'master-movement-strategy'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            reset() {
                this.strategyOptions.map(item => {
                    if(item.id == 1) {
                        item.enable = false
                    }
                })
            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>
<style>
.list-item {
  transition: all 1s
}
</style>